module.exports = {
  "title": "invulnerable",
  "id": "invulnerable",
  "info": [
    {
      "text": "Make a piece invulnerable to pieces with hazard <i class='icon icon-tombstone red'></i> sticker",
      "image": "provision/glitches/invulnerable/invulnerable.gif"
    }
  ],
  "category": "destroy",
  "color": "blue",
  "icon": "shield",
  "exposedVariables": [ ],
  "codeImage": "provision/glitches/invulnerable/invulnerable.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/invulnerable/invulnerable.svg"
};